module.exports = __webpack_public_path__ + "img/step1.9fbf2ec0.png";